import http, {download, uploadCfg} from "../../../utils/HttpUtils";

//销售单接口服务
class SaleSoService {
    /*****************************************************************************/

    //新建销售单
    static async insert(data) {
        const apiUrl = "/sale/so/insert";
        return await http.post(apiUrl, data);
    }

    //修改销售单
    static async update(data) {
        const apiUrl = "/sale/so/update";
        return await http.post(apiUrl, data);
    }


    //分页查询销售单信息
    static async findPage(data) {
        const apiUrl = "/sale/so/findPage";
        return await http.post(apiUrl, data);
    }

    //根据id或code查询销售单明细
    static async findByIdOrCode(idOrCode) {
        const apiUrl = "/sale/so/findByIdOrCode/" + idOrCode;
        return await http.get(apiUrl);
    }

    //作废
    static async disable(id) {
        const apiUrl = "/sale/so/disable/" + id;
        return await http.get(apiUrl);
    }

    //仓库确认
    static async whConfirm(id) {
        const apiUrl = "/sale/so/whConfirm/" + id;
        return await http.get(apiUrl);
    }

    //结算
    static async settle(data) {
        const apiUrl = "/sale/so/settle";
        return await http.post(apiUrl, data);
    }

    //导出
    static async export(data) {
        const apiUrl = `/sale/so/export`;
        return await download(apiUrl, {type: "POST", data});
    }

    /*****************************************************************************/

    //销售单明细查询
    static async findDetailPage(data) {
        const apiUrl = "/sale/so/detail/findDetailPage";
        return await http.post(apiUrl, data);
    }

    //下载明细导入模板
    static async downloadDetailTpl() {
        const apiUrl = `/sale/so/detail/downloadTpl`;
        await download(apiUrl,)
    }

    //获取导入配置
    static getImportDetailCfg(cfg, priceType = null) {
        const apiUrl = "/sale/so/detail/import/" + priceType;
        return uploadCfg(apiUrl, cfg);
    }

    /*****************************************************************************/
}

export default SaleSoService;
